import { Component, OnInit, Input } from '@angular/core';
import { FormControl, FormGroup, Validators, FormArray, FormBuilder } from '@angular/forms'
import { Router } from '@angular/router';
import { Refresh } from '@ngrx/store-devtools/src/actions';
import * as L from "leaflet";
import { PhameeService } from '../../services/phamee.service';
declare var $: any;
import { NgxSpinnerService } from 'ngx-spinner';
import * as moment from 'moment';
import * as XLSX from 'xlsx';

@Component({
  selector: 'smart-plot-growth',
  templateUrl: './plot-growth.component.html',
  styleUrls: ['./plot-growth.component.css','../platform-color/platform-color.css']
})
export class PlotGrowthComponent implements OnInit {
  step = 1;
  trunk = false;
  flowerperpole = false;
  flowerperbouquet = false;
  sheath = false;
  @Input() plotId: string;
  @Input() farmId: string;
  @Input() cropId: string;
  @Input() zoneId: string;
  userrole = sessionStorage.getItem("role");
  
  map: L.Map;
  map_focus: L.Map;
  polygon;
  marker;
  drawPluginOptions;
  numberOfLatLong = [];
  centerpoint = [];
  numberPloe = [];
  growthFormdata: any;
  FormSubmit: FormGroup
  FormCommonList: FormGroup
  FormInflorescenseList: FormGroup

  collectDate: any = null;
  collectDateString: any;
  currentPolygon: any;
  collectDateDDMMYYYY
  cropPoleId: any;
  cropPoleName: any;
  inflorescenceId: any;
  inflorescenceName: any;
  poleNo: any = '0';
  inflorescenceNo: any = '0';
  cropPoleList: any = [];
  inflorescenceList: any = [];
  stemLengthPreviousValue: any;
  numberOfInternodePreviousValue: any;
  numberOfShootTipPreviousValue: any;
  numberOfInflorescencePreviousValue: any;
  numberOfTrimInflorescencePreviousValue: any;

  numberOfGoodFlowerValue: any;
  numberOfGoodPodValue: any;

  ExstemLengthValue: any;
  ExstemSizeValue: any;
  ExnnumberOfLeafValue: any;
  ExnumberOfInternodeValue: any;
  ExnumberOfShootTipValue: any;
  ExnumberOfInflorescenceValue: any;
  ExnumberOfTrimInflorescenceValue: any;

  ExstemLengthOperator: any;
  ExstemSizeOperator: any;
  ExnnumberOfLeafOperator: any;
  ExnumberOfInternodeOperator: any;
  ExnumberOfShootTipOperator: any;
  ExnumberOfInflorescenceOperator: any;
  ExnumberOfTrimInflorescenceOperator: any;

  ExstemLengthBefore: any;
  ExstemSizeBefore: any;
  ExnnumberOfLeafBefore: any;
  ExnumberOfInternodeBefore: any;
  ExnumberOfShootTipBefore: any;
  ExnumberOfInflorescenceBefore: any;
  ExnumberOfTrimInflorescenceBefore: any;

  ExstemLengthSum: any;
  ExstemSizeSum: any;
  ExnnumberOfLeafSum: any;
  ExnumberOfInternodeSum: any;
  ExnumberOfShootTipSum: any;
  ExnumberOfInflorescenceSum: any;
  ExnumberOfTrimInflorescenceSum: any;

  SumstemLengthValue: any = null;
  SumstemSizeValue: any = null;
  SumnumberOfLeafValue: any = null;
  SumnumberOfInternodeValue: any = null;
  SumnumberOfShootTipValue: any = null;
  SumnumberOfInflorescenceValue: any = null;
  SumnumberOfTrimInflorescenceValue: any = null;

  _id: any;
  growth_type: any;
  inflorescence_no: any;
  is_experiment: any;
  experiments: any = '';
  tableHeader: any = [];
  tableRows: any = [];
  limit: number = 5;
  page: number = 1;
  total: any;
  constructor(
    private router: Router,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private phameeService: PhameeService,
  ) {

    this.FormCommonList = this.fb.group({
      stemLengthId: '',
      stemLengthNo: '',
      stemLengthInputType: '',
      stemLengthCropGrowth: '',
      stemLengthOperator: '',
      stemLengthValue: '',
      stemLengthBefore: '',

      stemSizeId: '',
      stemSizeNo: '',
      stemSizeInputType: '',
      stemSizeCropGrowth: '',
      stemSizeOperator: '',
      stemSizeValue: '',
      stemSizeBefore: '',

      numberOfLeafId: '',
      numberOfLeafNo: '',
      numberOfLeafInputType: '',
      numberOfLeafCropGrowth: '',
      numberOfLeafOperator: '',
      numberOfLeafValue: '',
      numberOfLeafBefore: '',

      numberOfInternodeId: '',
      numberOfInternodeNo: '',
      numberOfInternodeInputType: '',
      numberOfInternodeCropGrowth: '',
      numberOfInternodeOperator: '',
      numberOfInternodeValue: '',
      numberOfInternodeBefore: '',

      numberOfShootTipId: '',
      numberOfShootTipNo: '',
      numberOfShootTipInputType: '',
      numberOfShootTipCropGrowth: '',
      numberOfShootTipOperator: '',
      numberOfShootTipValue: '',
      numberOfShootTipBefore: '',

      numberOfInflorescenceId: '',
      numberOfInflorescenceNo: '',
      numberOfInflorescenceInputType: '',
      numberOfInflorescenceCropGrowth: '',
      numberOfInflorescenceOperator: '',
      numberOfInflorescenceValue: '',
      numberOfInflorescenceBefore: '',

      numberOfTrimInflorescenceId: '',
      numberOfTrimInflorescenceNo: '',
      numberOfTrimInflorescenceInputType: '',
      numberOfTrimInflorescenceCropGrowth: '',
      numberOfTrimInflorescenceOperator: '',
      numberOfTrimInflorescenceValue: '',
      numberOfTrimInflorescenceBefore: '',

    });
    this.FormInflorescenseList = this.fb.group({
      numberOffFlowerInflorescenceId: '',
      numberOffFlowerInflorescenceNo: '',
      numberOffFlowerInflorescenceInputType: '',
      numberOffFlowerInflorescenceCropGrowth: '',
      numberOffFlowerInflorescenceOperator: '',
      numberOffFlowerInflorescenceValue: '',
      numberOffFlowerInflorescenceBefore: '',

      numberOfFailFlowerId: '',
      numberOfFailFlowerNo: '',
      numberOfFailFlowerInputType: '',
      numberOfFailFlowerCropGrowth: '',
      numberOfFailFlowerOperator: '',
      numberOfFailFlowerValue: '',
      numberOfFailFlowerBefore: '',

      numberOfGoodFlowerId: '',
      numberOfGoodFlowerNo: '',
      numberOfGoodFlowerInputType: '',
      numberOfGoodFlowerCropGrowth: '',
      numberOfGoodFlowerOperator: '',
      numberOfGoodFlowerValue: '',
      numberOfGoodFlowerBefore: '',
      numberOfGoodFlowerFormula: [],

      numberOfAllPodId: '',
      numberOfAllPodNo: '',
      numberOfAllPodInputType: '',
      numberOfAllPodCropGrowth: '',
      numberOfAllPodOperator: '',
      numberOfAllPodValue: '',
      numberOfAllPodBefore: '',

      numberOfRottenPodId: '',
      numberOfRottenPodNo: '',
      numberOfRottenPodInputType: '',
      numberOfRottenPodCropGrowth: '',
      numberOfRottenPodOperator: '',
      numberOfRottenPodValue: '',
      numberOfRottenPodBefore: '',

      numberOfFallenPodId: '',
      numberOfFallenPodNo: '',
      numberOfFallenPodInputType: '',
      numberOfFallenPodCropGrowth: '',
      numberOfFallenPodOperator: '',
      numberOfFallenPodValue: '',
      numberOfFallenPodBefore: '',

      numberOfPodProblemsId: '',
      numberOfPodProblemsNo: '',
      numberOfPodProblemsInputType: '',
      numberOfPodProblemsCropGrowth: '',
      numberOfPodProblemsOperator: '',
      numberOfPodProblemsValue: '',
      numberOfPodProblemsBefore: '',

      numberOfBreedingIssueId: '',
      numberOfBreedingIssueNo: '',
      numberOfBreedingIssueInputType: '',
      numberOfBreedingIssueCropGrowth: '',
      numberOfBreedingIssueOperator: '',
      numberOfBreedingIssueValue: '',
      numberOfBreedingIssueBefore: '',

      numberOfGoodPodId: '',
      numberOfGoodPodNo: '',
      numberOfGoodPodInputType: '',
      numberOfGoodPodCropGrowth: '',
      numberOfGoodPodOperator: '',
      numberOfGoodPodValue: '',
      numberOfGoodPodBefore: '',
      numberOfGoodPodFormula: [],

    });
  }

  checkData(data){
    if(data) return data
    return '-'
  }
  ngOnInit(): void {
    this.getbyCropId(this.page);
    // this.spinner.show();
    setTimeout(async () => {
      $('.select2').select2();
    }, 1000);
  }
  getbyCropId(page: number) {
    this.spinner.show();
    let data = {
      crop_id: this.cropId,
      limit: this.limit,
      page_no: page,
    }
    this.phameeService.getbyCropId(data)
      .subscribe(async success => {
        console.log("getbyCropId data : ", data)
        console.log("getbyCropId success : ", success)
        if (success.code == 200) {
          let response = success.data;
          this.tableHeader = response.table_header;
          if(response.table_row){
            this.tableRows = response.table_row.data;
            this.limit = response.table_row.limit;
            this.page = response.table_row.page_no;
            if (response.table_row.data.length == response.table_row.total_rows) {
              if(this.limit !== response.table_row.data.length)this.total = response.table_row.total_rows + 1  
              else this.total = response.table_row.total_rows            
            }else{
              this.total = response.table_row.total_rows
            }

            // this.total = response.table_row.total_rows;
          }else{
            this.tableRows = []
          }
          console.log("getbyCropIdthis.tableHeader  :", this.tableHeader);
          console.log("getbyCropIdthis.tableRows  :", this.tableRows);
          console.log("getbyCropIdthis.total  :", this.total);
        }
        this.spinner.hide();
      });
  }

  getPages(pageNoGrowth: number) {
    this.page = pageNoGrowth;
    this.getbyCropId(this.page);
  }

  getPlotforMap(date,map_id) {
    console.log("getPlotforMap : ",map_id)
    this.phameeService.getPlotbyPlotId(this.plotId)
      .subscribe(async success => {
        console.log("plot grownth !@!!!! success : ", success)
        if (success.code == 200) {
          let data = success.data;
          console.log("data : ", data)

          this.currentPolygon = {
            coordinates: data[0].coordinates,
            zone: {
              color: data[0].zone.color,
              name: data[0].zone.name
            }
          }
          await this.getMap(this.currentPolygon, date,map_id)

          // data.forEach(element => {
          //   this.BreedTypeList.push({
          //     name: element.name,
          //     value: element._id
          //   })
          // });
        }
      });
  }
  async getMap(polygon, date,map_id) {
    console.log("plot getMap polygon : ", polygon)
    console.log("plot getMap date : ", date)
    console.log("plot getMap map_id : ", map_id)
    console.log("this.map : ", this.map)
    this.numberOfLatLong = [];
    if (this.map) {
      this.map.remove();
      this.map = null;
    }
    this.map = L.map(map_id, { zoomControl: false }).setView([polygon.coordinates.center.lat, polygon.coordinates.center.lon], polygon.coordinates.center.zoom_lv);
    L.control.zoom({ position: 'topright' }).addTo(this.map);
    L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', { maxNativeZoom: 17, maxZoom: 18, minZoom: 5 })
      .addTo(this.map);
    for (let lt = 0; lt < polygon.coordinates.map_polygon.length; lt++) {
      this.numberOfLatLong[lt] = [polygon.coordinates.map_polygon[lt].lat, polygon.coordinates.map_polygon[lt].lon];
    }
    let latlong = this.numberOfLatLong;
    console.log("plot grownth latlong ::: ", latlong)
    this.polygon = L.polygon(
      [
        [latlong],
      ],
      {
        color: polygon.zone.color,
        fillColor: polygon.zone.color,
        fillOpacity: 0.2,

      },
    ).addTo(this.map);
    this.polygon.bindPopup(polygon.zone.name);
    console.log("b4 getCropPloe :", date)
    this.getCropPloe(date)

  }
  getCropPloe(dateString) {
    console.log("getCropPloe : ", dateString)
    this.phameeService.getCropPoleByCropId(this.cropId, dateString)
      .subscribe(async success => {
        console.log("plot grownth getCropPloe success : ", success)
        if (success.code == 200) {
          let data = success.data;
          console.log("plot grownth data : ", data)
          if (data.length > 0) {
            let cropPoleArray = [];
            for (let i = 0; i < data.length; i++) {
              this.numberPloe[i] = [data[i].coordinates.map_point.lat, data[i].coordinates.map_point.lon];
              let label: string = '<img style="width: 28px;height: 33px;" src="./assets/img/' + data[i].marker + '.png" alt=""><div style="text-align: center;width:28px;color: #000000;  position: absolute;top: 5%;"> ' + data[i].no + ' </div>';
              this.marker = L.marker(this.numberPloe[i], {
                icon: L.divIcon({
                  className: "number-icon",
                  iconSize: [30, 30],
                  iconAnchor: [15, 40],
                  popupAnchor: [3, -40],
                  html: label
                })
              }).addTo(this.map);
              cropPoleArray.push({
                id: data[i]._id,
                text: data[i].name
              })

            }
            this.cropPoleList = cropPoleArray
            console.log("this.cropPoleList : ", this.cropPoleList)
            this.cropPoleList.sort(function (a, b) {
              if (b.text.localeCompare(a.text)) { return 1; }
              if (b.text.localeCompare(a.text)) { return -1; }
              return 0;
            });
            console.log("this.cropPoleList : ", this.cropPoleList)

          }
        }
        this.spinner.hide();

      });
  }

  selectstartDate(e) {
    console.log("getCropPloe selectstartDate e: ", e)
    this.collectDate = e
    this.cropPoleId = null
    this.poleNo = 0
    console.log("getCropPloe selectstartDate : ", this.collectDate)
    console.log("poleNo : ",this.poleNo)
    console.log("cropPoleId : ",this.cropPoleId)
    if(this.poleNo) console.log("YEP!")
    let date = null;
    if (e !== null) {
      date = moment(this.collectDate, 'YYYY-MM-DD HH:mm:ss', 'Asia/Bangkok').format('YYYY-MM-DD')
      this.cropPoleId = null
      this.poleNo = 0
      this.growthFormdata = null
      this.getCropPloe(date)
      // if(this.cropPoleId) this.selectPloe(this.cropPoleId)
    }
  }

  selectPloe(e) {
    let date = moment(this.collectDate, 'YYYY-MM-DD HH:mm:ss', 'Asia/Bangkok').format('YYYY-MM-DD')
    console.log("date", date)
    this.collectDateString = date;
    this.cropPoleId = e;
    console.log("poleNo : ",this.poleNo)
    console.log("cropPoleId : ",this.cropPoleId)
    let cropPoleName = this.cropPoleList.filter(x => x.id == e)
    this.cropPoleName = cropPoleName[0].text
    console.log("cropPoleName : ", cropPoleName[0].text)
    console.log("this.cropPoleName : ", this.cropPoleName)
    let data = {
      cropId: this.cropId,
      poleId: e,
      collectDate: date
    }
    if (date) {
      this.spinner.show();
      this.phameeService.getFormGrowData(data)
        .subscribe(async success => {
          console.log("success : ", success)
          if (success.code == 200) {
            this.growthFormdata = success.data
            console.log("v this.growthFormdata[0] : ", this.growthFormdata[0])
            for (let i = 0; i < this.growthFormdata[0].length; i++) {
              const element = this.growthFormdata[0][i];
              for (let j = 0; j < element.length; j++) {
                const elements = element[j];
                // console.log("v elements : ", elements)
                switch (elements.no) {
                  case 1:
                    console.log("1 ")
                    this.stemLengthPreviousValue = elements.before == null ? '-' : elements.before
                    this.ExstemLengthValue = elements.value
                    this.ExstemLengthOperator = elements.operator
                    this.ExstemLengthBefore = elements.before
                    this.ExstemLengthSum = elements.sum
                    this.FormCommonList.controls["stemLengthId"].setValue(elements._id);
                    this.FormCommonList.controls["stemLengthNo"].setValue(elements.no);
                    this.FormCommonList.controls["stemLengthInputType"].setValue(elements.input_type);
                    this.FormCommonList.controls["stemLengthCropGrowth"].setValue(elements.growth);
                    this.FormCommonList.controls["stemLengthOperator"].setValue(elements.operator == "+" ? true : false);
                    this.FormCommonList.controls["stemLengthValue"].setValue(elements.value == null ? '' : elements.value);
                    this.FormCommonList.controls["stemLengthBefore"].setValue(elements.before);
                    break;
                  case 2:
                    console.log("2 ", elements.value)
                    this.ExstemSizeValue = elements.value
                    this.ExstemSizeOperator = elements.operator
                    this.ExstemSizeBefore = elements.before
                    this.ExstemSizeSum = elements.sum

                    this.FormCommonList.controls["stemSizeId"].setValue(elements._id);
                    this.FormCommonList.controls["stemSizeNo"].setValue(elements.no);
                    this.FormCommonList.controls["stemSizeInputType"].setValue(elements.input_type);
                    this.FormCommonList.controls["stemSizeCropGrowth"].setValue(elements.growth);
                    this.FormCommonList.controls["stemSizeOperator"].setValue(elements.operator == "+" ? true : false);
                    this.FormCommonList.controls["stemSizeValue"].setValue(elements.value == null ? '' : elements.value);
                    this.FormCommonList.controls["stemSizeBefore"].setValue(elements.before);
                    break;
                  case 3:
                    console.log("3 ")
                    this.ExnnumberOfLeafValue = elements.value
                    this.ExnnumberOfLeafOperator = elements.operator
                    this.ExnnumberOfLeafBefore = elements.before
                    this.ExnnumberOfLeafSum = elements.sum

                    this.FormCommonList.controls["numberOfLeafId"].setValue(elements._id);
                    this.FormCommonList.controls["numberOfLeafNo"].setValue(elements.no);
                    this.FormCommonList.controls["numberOfLeafInputType"].setValue(elements.input_type);
                    this.FormCommonList.controls["numberOfLeafCropGrowth"].setValue(elements.growth);
                    this.FormCommonList.controls["numberOfLeafOperator"].setValue(elements.operator == "+" ? true : false);
                    this.FormCommonList.controls["numberOfLeafValue"].setValue(elements.value == null ? '' : elements.value);
                    this.FormCommonList.controls["numberOfLeafBefore"].setValue(elements.before);
                    break;
                  case 4:
                    console.log("4 ")
                    this.ExnumberOfInternodeValue = elements.value
                    this.ExnumberOfInternodeOperator = elements.operator
                    this.ExnumberOfInternodeBefore = elements.before
                    this.ExnumberOfInternodeSum = elements.sum


                    this.numberOfInternodePreviousValue = elements.before == null ? '-' : elements.before
                    this.FormCommonList.controls["numberOfInternodeId"].setValue(elements._id);
                    this.FormCommonList.controls["numberOfInternodeNo"].setValue(elements.no);
                    this.FormCommonList.controls["numberOfInternodeInputType"].setValue(elements.input_type);
                    this.FormCommonList.controls["numberOfInternodeCropGrowth"].setValue(elements.growth);
                    this.FormCommonList.controls["numberOfInternodeOperator"].setValue(elements.operator == "+" ? true : false);
                    this.FormCommonList.controls["numberOfInternodeValue"].setValue(elements.value == null ? '' : elements.value);
                    this.FormCommonList.controls["numberOfInternodeBefore"].setValue(elements.before);
                    break;
                  case 5:
                    console.log("5 ")
                    this.ExnumberOfShootTipValue = elements.value
                    this.ExnumberOfShootTipOperator = elements.operator
                    this.ExnumberOfShootTipBefore = elements.before
                    this.ExnumberOfShootTipSum = elements.sum

                    this.numberOfShootTipPreviousValue = elements.before == null ? '-' : elements.before
                    this.FormCommonList.controls["numberOfShootTipId"].setValue(elements._id);
                    this.FormCommonList.controls["numberOfShootTipNo"].setValue(elements.no);
                    this.FormCommonList.controls["numberOfShootTipInputType"].setValue(elements.input_type);
                    this.FormCommonList.controls["numberOfShootTipCropGrowth"].setValue(elements.growth);
                    this.FormCommonList.controls["numberOfShootTipOperator"].setValue(elements.operator == "+" ? true : false);
                    this.FormCommonList.controls["numberOfShootTipValue"].setValue(elements.value == null ? '' : elements.value);
                    this.FormCommonList.controls["numberOfShootTipBefore"].setValue(elements.before);
                    break;
                  case 6:
                    console.log("6 ")
                    this.ExnumberOfInflorescenceValue = elements.value
                    this.ExnumberOfInflorescenceOperator = elements.operator
                    this.ExnumberOfInflorescenceBefore = elements.before
                    this.ExnumberOfInflorescenceSum = elements.sum

                    this.numberOfInflorescencePreviousValue = elements.before == null ? '-' : elements.before
                    this.FormCommonList.controls["numberOfInflorescenceId"].setValue(elements._id);
                    this.FormCommonList.controls["numberOfInflorescenceNo"].setValue(elements.no);
                    this.FormCommonList.controls["numberOfInflorescenceInputType"].setValue(elements.input_type);
                    this.FormCommonList.controls["numberOfInflorescenceCropGrowth"].setValue(elements.growth);
                    this.FormCommonList.controls["numberOfInflorescenceOperator"].setValue(elements.operator == "+" ? true : false);
                    this.FormCommonList.controls["numberOfInflorescenceValue"].setValue(elements.value == null ? '' : elements.value);
                    this.FormCommonList.controls["numberOfInflorescenceBefore"].setValue(elements.before);
                    break;
                  case 7:
                    console.log("7 ")
                    this.ExnumberOfTrimInflorescenceValue = elements.value
                    this.ExnumberOfTrimInflorescenceOperator = elements.operator
                    this.ExnumberOfTrimInflorescenceBefore = elements.before
                    this.ExnumberOfTrimInflorescenceSum = elements.sum

                    this.numberOfTrimInflorescencePreviousValue = elements.before == null ? '-' : elements.before
                    this.FormCommonList.controls["numberOfTrimInflorescenceId"].setValue(elements._id);
                    this.FormCommonList.controls["numberOfTrimInflorescenceNo"].setValue(elements.no);
                    this.FormCommonList.controls["numberOfTrimInflorescenceInputType"].setValue(elements.input_type);
                    this.FormCommonList.controls["numberOfTrimInflorescenceCropGrowth"].setValue(elements.growth);
                    this.FormCommonList.controls["numberOfTrimInflorescenceOperator"].setValue(elements.operator == "+" ? true : false);
                    this.FormCommonList.controls["numberOfTrimInflorescenceValue"].setValue(elements.value == null ? '' : elements.value);
                    this.FormCommonList.controls["numberOfTrimInflorescenceBefore"].setValue(elements.before);
                    break;
                }
              }

            }
          }
          console.log("growthFormdata : ", this.growthFormdata)
          console.log("FormCommonList : ", this.FormCommonList)

          this.spinner.hide();
        })

    }

  }

  autocal(id) {
    console.log("autocal  : ", this.FormInflorescenseList.get(id).value)
    if (id == 'numberOfGoodFlowerValue') {
      let formula = this.FormInflorescenseList.get('numberOfGoodFlowerFormula').value
      let data = 0
      for (let i = 0; i < formula.length; i++) {
        const element = formula[i];
        console.log("data : ", data)
        if (element.operator == '+') {
          data += this.FormInflorescenseList.get(`${element.param}Value`).value
        } else {
          data -= this.FormInflorescenseList.get(`${element.param}Value`).value
        }
      }
      this.FormInflorescenseList.controls["numberOfGoodFlowerValue"].setValue(data);
    }
    if (id == 'numberOfGoodPodValue') {
      let formula = this.FormInflorescenseList.get('numberOfGoodPodFormula').value
      let data = 0
      console.log("formula : ", formula)
      for (let i = 0; i < formula.length; i++) {
        const element = formula[i];
        console.log("data : ", data)
        if (element.operator == '+') {
          data += this.FormInflorescenseList.get(`${element.param}Value`).value
        } else {
          data -= this.FormInflorescenseList.get(`${element.param}Value`).value
        }
      }
      this.FormInflorescenseList.controls["numberOfGoodPodValue"].setValue(data);

      console.log("data : ", data)
    }

  }
  selectInflorescence(e) {
    console.log("SELECTED", e)
    console.log("collectDate", this.collectDate)
    let date = moment(this.collectDate, 'YYYY-MM-DD HH:mm:ss', 'Asia/Bangkok').format('YYYY-MM-DD')
    console.log("date", this.inflorescenceList)
    let inflorescenceName = this.inflorescenceList.filter(x => x.id == e)
    this.inflorescenceName = inflorescenceName[0].text
    this.inflorescenceId = e
    this.collectDateString = date;
    let data = {
      cropId: this.cropId,
      poleId: this.cropPoleId,
      collectDate: date,
      inflorescenceNo: e
    }
    this.spinner.show();
    this.phameeService.getFormGrowInflorescenceData(data)
      .subscribe(async success => {
        console.log("success: ", success)
        if (success.code == 200) {
          let inflorescenceData = success.data;
          for (let i = 0; i < inflorescenceData.length; i++) {
            const element = inflorescenceData[i];
            for (let j = 0; j < element.length; j++) {
              const elements = element[j];
              // console.log("v elements : ", elements)
              switch (elements.no) {
                case 8:
                  this.FormInflorescenseList.controls["numberOffFlowerInflorescenceId"].setValue(elements._id);
                  this.FormInflorescenseList.controls["numberOffFlowerInflorescenceNo"].setValue(elements.no);
                  this.FormInflorescenseList.controls["numberOffFlowerInflorescenceInputType"].setValue(elements.input_type);
                  this.FormInflorescenseList.controls["numberOffFlowerInflorescenceCropGrowth"].setValue(elements.growth);
                  this.FormInflorescenseList.controls["numberOffFlowerInflorescenceOperator"].setValue(elements.operator == "+" ? true : false);
                  this.FormInflorescenseList.controls["numberOffFlowerInflorescenceValue"].setValue(elements.value == null ? '' : elements.value);
                  this.FormInflorescenseList.controls["numberOffFlowerInflorescenceBefore"].setValue(elements.before);
                  break;
                case 9:
                  this.FormInflorescenseList.controls["numberOfFailFlowerId"].setValue(elements._id);
                  this.FormInflorescenseList.controls["numberOfFailFlowerNo"].setValue(elements.no);
                  this.FormInflorescenseList.controls["numberOfFailFlowerInputType"].setValue(elements.input_type);
                  this.FormInflorescenseList.controls["numberOfFailFlowerCropGrowth"].setValue(elements.growth);
                  this.FormInflorescenseList.controls["numberOfFailFlowerOperator"].setValue(elements.operator == "+" ? true : false);
                  this.FormInflorescenseList.controls["numberOfFailFlowerValue"].setValue(elements.value == null ? '' : elements.value);
                  this.FormInflorescenseList.controls["numberOfFailFlowerBefore"].setValue(elements.before);
                  break;
                case 10:
                  this.numberOfGoodFlowerValue = elements.value == null ? '-' : elements.value
                  this.FormInflorescenseList.controls["numberOfGoodFlowerId"].setValue(elements._id);
                  this.FormInflorescenseList.controls["numberOfGoodFlowerNo"].setValue(elements.no);
                  this.FormInflorescenseList.controls["numberOfGoodFlowerInputType"].setValue(elements.input_type);
                  this.FormInflorescenseList.controls["numberOfGoodFlowerCropGrowth"].setValue(elements.growth);
                  this.FormInflorescenseList.controls["numberOfGoodFlowerOperator"].setValue(elements.operator == "+" ? true : false);
                  this.FormInflorescenseList.controls["numberOfGoodFlowerValue"].setValue(elements.value == null ? '' : elements.value);
                  this.FormInflorescenseList.controls["numberOfGoodFlowerBefore"].setValue(elements.before);
                  this.FormInflorescenseList.controls["numberOfGoodFlowerFormula"].setValue(elements.formula);

                  break;
                case 11:
                  this.FormInflorescenseList.controls["numberOfAllPodId"].setValue(elements._id);
                  this.FormInflorescenseList.controls["numberOfAllPodNo"].setValue(elements.no);
                  this.FormInflorescenseList.controls["numberOfAllPodInputType"].setValue(elements.input_type);
                  this.FormInflorescenseList.controls["numberOfAllPodCropGrowth"].setValue(elements.growth);
                  this.FormInflorescenseList.controls["numberOfAllPodOperator"].setValue(elements.operator == "+" ? true : false);
                  this.FormInflorescenseList.controls["numberOfAllPodValue"].setValue(elements.value == null ? '' : elements.value);
                  this.FormInflorescenseList.controls["numberOfAllPodBefore"].setValue(elements.before);
                  break;
                case 12:
                  this.FormInflorescenseList.controls["numberOfRottenPodId"].setValue(elements._id);
                  this.FormInflorescenseList.controls["numberOfRottenPodNo"].setValue(elements.no);
                  this.FormInflorescenseList.controls["numberOfRottenPodInputType"].setValue(elements.input_type);
                  this.FormInflorescenseList.controls["numberOfRottenPodCropGrowth"].setValue(elements.growth);
                  this.FormInflorescenseList.controls["numberOfRottenPodOperator"].setValue(elements.operator == "+" ? true : false);
                  this.FormInflorescenseList.controls["numberOfRottenPodValue"].setValue(elements.value == null ? '' : elements.value);
                  this.FormInflorescenseList.controls["numberOfRottenPodBefore"].setValue(elements.before);
                  break;
                case 13:
                  this.FormInflorescenseList.controls["numberOfFallenPodId"].setValue(elements._id);
                  this.FormInflorescenseList.controls["numberOfFallenPodNo"].setValue(elements.no);
                  this.FormInflorescenseList.controls["numberOfFallenPodInputType"].setValue(elements.input_type);
                  this.FormInflorescenseList.controls["numberOfFallenPodCropGrowth"].setValue(elements.growth);
                  this.FormInflorescenseList.controls["numberOfFallenPodOperator"].setValue(elements.operator == "+" ? true : false);
                  this.FormInflorescenseList.controls["numberOfFallenPodValue"].setValue(elements.value == null ? '' : elements.value);
                  this.FormInflorescenseList.controls["numberOfFallenPodBefore"].setValue(elements.before);
                  break;
                case 14:
                  this.FormInflorescenseList.controls["numberOfPodProblemsId"].setValue(elements._id);
                  this.FormInflorescenseList.controls["numberOfPodProblemsNo"].setValue(elements.no);
                  this.FormInflorescenseList.controls["numberOfPodProblemsInputType"].setValue(elements.input_type);
                  this.FormInflorescenseList.controls["numberOfPodProblemsCropGrowth"].setValue(elements.growth);
                  this.FormInflorescenseList.controls["numberOfPodProblemsOperator"].setValue(elements.operator == "+" ? true : false);
                  this.FormInflorescenseList.controls["numberOfPodProblemsValue"].setValue(elements.value == null ? '' : elements.value);
                  this.FormInflorescenseList.controls["numberOfPodProblemsBefore"].setValue(elements.before);
                  break;
                case 15:
                  this.FormInflorescenseList.controls["numberOfBreedingIssueId"].setValue(elements._id);
                  this.FormInflorescenseList.controls["numberOfBreedingIssueNo"].setValue(elements.no);
                  this.FormInflorescenseList.controls["numberOfBreedingIssueInputType"].setValue(elements.input_type);
                  this.FormInflorescenseList.controls["numberOfBreedingIssueCropGrowth"].setValue(elements.growth);
                  this.FormInflorescenseList.controls["numberOfBreedingIssueOperator"].setValue(elements.operator == "+" ? true : false);
                  this.FormInflorescenseList.controls["numberOfBreedingIssueValue"].setValue(elements.value == null ? '' : elements.value);
                  this.FormInflorescenseList.controls["numberOfBreedingIssueBefore"].setValue(elements.before);
                  break;
                case 16:
                  this.FormInflorescenseList.controls["numberOfGoodPodId"].setValue(elements._id);
                  this.FormInflorescenseList.controls["numberOfGoodPodNo"].setValue(elements.no);
                  this.FormInflorescenseList.controls["numberOfGoodPodInputType"].setValue(elements.input_type);
                  this.FormInflorescenseList.controls["numberOfGoodPodCropGrowth"].setValue(elements.growth);
                  this.FormInflorescenseList.controls["numberOfGoodPodOperator"].setValue(elements.operator == "+" ? true : false);
                  this.FormInflorescenseList.controls["numberOfGoodPodValue"].setValue(elements.value == null ? '' : elements.value);
                  this.FormInflorescenseList.controls["numberOfGoodPodBefore"].setValue(elements.before);
                  this.FormInflorescenseList.controls["numberOfGoodPodFormula"].setValue(elements.formula);

                  break;
              }
            }
          }
        }
        this.spinner.hide();
      })
    console.log("data : ", data)
  }


  getInflorescence() {
    this.phameeService.getInflorescence()
      .subscribe(async success => {
        let inflorescenceArray = [];
        if (success.code == 200) {
          let data = success.data
          data.sort(function (a, b) {
            if (a._id < b._id) { return -1; }
            if (a._id > b._id) { return 1; }
            return 0;
          });
          for (let i = 0; i < data.length; i++) {
            inflorescenceArray.push({
              id: data[i].param_id,
              text: data[i].param_name
            })
          }
          this.inflorescenceList = inflorescenceArray
        }
      })
  }

  
  export_growth() {
    this.spinner.show();
    this.phameeService.exportGrowthData(this.cropId)
      .subscribe(async success => {
        console.log("exportGrowthData success : ", success)
        if (success.code == 200) {
          let header = success.data.table_header
          let result = success.data.table_row
          let itemsFormatted = [];
          result.forEach(item => {
            console.log("exportGrowthData element ", item)
            itemsFormatted.push({
              'วันที่': item.date_string,
              'ลำดับเสา': item.pole,
              'รูปแบบ': item.is_experiment,
              'หมายเลขช่อดอก': item.inflorescence_name ? item.inflorescence_name : '-',
              'ความยาวลำต้น': item.stemLength ? item.stemLength : 0,
              'ขนาดลำต้น': item.stemSize ? item.stemSize : 0,
              'จำนวนใบต่อต้น (ใบ)': item.numberOfLeaf ? item.numberOfLeaf : 0,
              'จำนวนปล้อง (ปล้อง)': item.numberOfInternode ? item.numberOfInternode : 0,
              'จำนวนยอดต่อต้น (ยอด)': item.numberOfShootTip ? item.numberOfShootTip : 0,
              'จำนวนช่อดอกต่อเสา': item.numberOfInflorescence ? item.numberOfInflorescence : 0,
              'จำนวนช่อดอกที่ตัดแต่งออก': item.numberOfTrimInflorescence ? item.numberOfTrimInflorescence : 0,
              'จำนวนดอกต่อช่อทั้งหมด': item.numberOffFlowerInflorescence ? item.numberOffFlowerInflorescence : 0,
              'จำนวนดอกเสีย': item.numberOfFailFlower ? item.numberOfFailFlower : 0,
              'จำนวนดอกดี': item.numberOfGoodFlower ? item.numberOfGoodFlower : 0,
              'จำนวนฝักทั้งหมดต่อช่อ': item.numberOfAllPod ? item.numberOfAllPod : 0,
              'จำนวนฝักเน่า': item.numberOfRottenPod ? item.numberOfRottenPod : 0,
              'จำนวนฝักร่วง': item.numberOfFallenPod ? item.numberOfFallenPod : 0,
              'จำนวนฝักเสียไม่ทราบสาเหตุ': item.numberOfPodProblems ? item.numberOfPodProblems : 0,
              'จำนวนฝักที่ผสมแล้วไม่ติดฝัก': item.numberOfBreedingIssue ? item.numberOfBreedingIssue : 0,
              'จำนวนฝักดี': item.numberOfGoodPod ? item.numberOfGoodPod : 0,
            });
          });
          var fileName = 'บันทึกการเจริญเติบโต' + '.xlsx';
          var ws = XLSX.utils.json_to_sheet(itemsFormatted);
          var wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, "People");
          XLSX.writeFile(wb, fileName);
        }
        this.spinner.hide();
      });
  }
  preview_growth(id, growth_type, inflorescence_no, step) {
    console.log("preview_growth id,growth_type,inflorescence_no : ", id, growth_type, inflorescence_no)
    console.log("preview_growth this.currentPolygon ",this.currentPolygon);

    if (growth_type == "pole") {
      $('#tab_inflorescence_edit').removeClass('underline-li');
      $('#tab_pole_edit').addClass('underline-li');
    }else if (growth_type == "inflorescence") {
      $('#tab_pole_edit').removeClass('underline-li');
      $('#tab_inflorescence_edit').addClass('underline-li');
    }

    if (step !== null) this.step = step    
    this.experiments = ''
    let data = {
      id: id,
      growth_type: growth_type,
      inflorescence_no: inflorescence_no
    }
    console.log("preview_growth data : ", data)
    this.spinner.show();
    this.phameeService.getbyId(data)
      .subscribe(async success => {
        console.log("preview_growth success : ", success)
        if (success.code == 200) {
          let response = success.data
          this.is_experiment = response.is_experiment
          this.cropPoleName = response.crop_pole_name
          this.growth_type = growth_type;
          this.collectDate = this.DateDDMMYYYY(response.date_string)
          this.cropPoleId = response.crop_pole_id
          this.collectDateString = response.date_string
          if (response.experiments.length > 0) {
            for (let i = 0; i < response.experiments.length; i++) {
              const element = response.experiments[i];
              if (i == response.experiments.length - 1) {
                this.experiments += element
              } else {
                this.experiments += `${element}, `
              }
            }
          }
          if (growth_type == 'pole') {
            for (let i = 0; i < response.params_list.length; i++) {
              const element = response.params_list[i];
              for (let j = 0; j < element.length; j++) {
                const elements = element[j];
                // console.log("v elements : ", elements)
                switch (elements.no) {
                  case 1:
                    this.stemLengthPreviousValue = elements.before == null ? '-' : elements.before
                    this.ExstemLengthValue = elements.value
                    this.ExstemLengthOperator = elements.operator
                    this.ExstemLengthBefore = elements.before
                    this.ExstemLengthSum = elements.sum
                    this.FormCommonList.controls["stemLengthId"].setValue(elements._id);
                    this.FormCommonList.controls["stemLengthNo"].setValue(elements.no);
                    this.FormCommonList.controls["stemLengthInputType"].setValue(elements.input_type);
                    this.FormCommonList.controls["stemLengthCropGrowth"].setValue(elements.growth);
                    this.FormCommonList.controls["stemLengthOperator"].setValue(elements.operator == "+" ? true : false);
                    this.FormCommonList.controls["stemLengthValue"].setValue(elements.value == null ? '' : elements.value);
                    this.FormCommonList.controls["stemLengthBefore"].setValue(elements.before);
                    break;
                  case 2:
                    this.ExstemSizeValue = elements.value
                    this.ExstemSizeOperator = elements.operator
                    this.ExstemSizeBefore = elements.before
                    this.ExstemSizeSum = elements.sum

                    this.FormCommonList.controls["stemSizeId"].setValue(elements._id);
                    this.FormCommonList.controls["stemSizeNo"].setValue(elements.no);
                    this.FormCommonList.controls["stemSizeInputType"].setValue(elements.input_type);
                    this.FormCommonList.controls["stemSizeCropGrowth"].setValue(elements.growth);
                    this.FormCommonList.controls["stemSizeOperator"].setValue(elements.operator == "+" ? true : false);
                    this.FormCommonList.controls["stemSizeValue"].setValue(elements.value == null ? '' : elements.value);
                    this.FormCommonList.controls["stemSizeBefore"].setValue(elements.before);
                    break;
                  case 3:
                    console.log("3 ")
                    this.ExnnumberOfLeafValue = elements.value
                    this.ExnnumberOfLeafOperator = elements.operator
                    this.ExnnumberOfLeafBefore = elements.before
                    this.ExnnumberOfLeafSum = elements.sum

                    this.FormCommonList.controls["numberOfLeafId"].setValue(elements._id);
                    this.FormCommonList.controls["numberOfLeafNo"].setValue(elements.no);
                    this.FormCommonList.controls["numberOfLeafInputType"].setValue(elements.input_type);
                    this.FormCommonList.controls["numberOfLeafCropGrowth"].setValue(elements.growth);
                    this.FormCommonList.controls["numberOfLeafOperator"].setValue(elements.operator == "+" ? true : false);
                    this.FormCommonList.controls["numberOfLeafValue"].setValue(elements.value == null ? '' : elements.value);
                    this.FormCommonList.controls["numberOfLeafBefore"].setValue(elements.before);
                    break;
                  case 4:
                    console.log("4 ")
                    this.ExnumberOfInternodeValue = elements.value
                    this.ExnumberOfInternodeOperator = elements.operator
                    this.ExnumberOfInternodeBefore = elements.before
                    this.ExnumberOfInternodeSum = elements.sum


                    this.numberOfInternodePreviousValue = elements.before == null ? '-' : elements.before
                    this.FormCommonList.controls["numberOfInternodeId"].setValue(elements._id);
                    this.FormCommonList.controls["numberOfInternodeNo"].setValue(elements.no);
                    this.FormCommonList.controls["numberOfInternodeInputType"].setValue(elements.input_type);
                    this.FormCommonList.controls["numberOfInternodeCropGrowth"].setValue(elements.growth);
                    this.FormCommonList.controls["numberOfInternodeOperator"].setValue(elements.operator == "+" ? true : false);
                    this.FormCommonList.controls["numberOfInternodeValue"].setValue(elements.value == null ? '' : elements.value);
                    this.FormCommonList.controls["numberOfInternodeBefore"].setValue(elements.before);
                    break;
                  case 5:
                    console.log("5 ")
                    this.ExnumberOfShootTipValue = elements.value
                    this.ExnumberOfShootTipOperator = elements.operator
                    this.ExnumberOfShootTipBefore = elements.before
                    this.ExnumberOfShootTipSum = elements.sum

                    this.numberOfShootTipPreviousValue = elements.before == null ? '-' : elements.before
                    this.FormCommonList.controls["numberOfShootTipId"].setValue(elements._id);
                    this.FormCommonList.controls["numberOfShootTipNo"].setValue(elements.no);
                    this.FormCommonList.controls["numberOfShootTipInputType"].setValue(elements.input_type);
                    this.FormCommonList.controls["numberOfShootTipCropGrowth"].setValue(elements.growth);
                    this.FormCommonList.controls["numberOfShootTipOperator"].setValue(elements.operator == "+" ? true : false);
                    this.FormCommonList.controls["numberOfShootTipValue"].setValue(elements.value == null ? '' : elements.value);
                    this.FormCommonList.controls["numberOfShootTipBefore"].setValue(elements.before);
                    break;
                  case 6:
                    console.log("6 ")
                    this.ExnumberOfInflorescenceValue = elements.value
                    this.ExnumberOfInflorescenceOperator = elements.operator
                    this.ExnumberOfInflorescenceBefore = elements.before
                    this.ExnumberOfInflorescenceSum = elements.sum

                    this.numberOfInflorescencePreviousValue = elements.before == null ? '-' : elements.before
                    this.FormCommonList.controls["numberOfInflorescenceId"].setValue(elements._id);
                    this.FormCommonList.controls["numberOfInflorescenceNo"].setValue(elements.no);
                    this.FormCommonList.controls["numberOfInflorescenceInputType"].setValue(elements.input_type);
                    this.FormCommonList.controls["numberOfInflorescenceCropGrowth"].setValue(elements.growth);
                    this.FormCommonList.controls["numberOfInflorescenceOperator"].setValue(elements.operator == "+" ? true : false);
                    this.FormCommonList.controls["numberOfInflorescenceValue"].setValue(elements.value == null ? '' : elements.value);
                    this.FormCommonList.controls["numberOfInflorescenceBefore"].setValue(elements.before);
                    break;
                  case 7:
                    console.log("7 ")
                    this.ExnumberOfTrimInflorescenceValue = elements.value
                    this.ExnumberOfTrimInflorescenceOperator = elements.operator
                    this.ExnumberOfTrimInflorescenceBefore = elements.before
                    this.ExnumberOfTrimInflorescenceSum = elements.sum

                    this.numberOfTrimInflorescencePreviousValue = elements.before == null ? '-' : elements.before
                    this.FormCommonList.controls["numberOfTrimInflorescenceId"].setValue(elements._id);
                    this.FormCommonList.controls["numberOfTrimInflorescenceNo"].setValue(elements.no);
                    this.FormCommonList.controls["numberOfTrimInflorescenceInputType"].setValue(elements.input_type);
                    this.FormCommonList.controls["numberOfTrimInflorescenceCropGrowth"].setValue(elements.growth);
                    this.FormCommonList.controls["numberOfTrimInflorescenceOperator"].setValue(elements.operator == "+" ? true : false);
                    this.FormCommonList.controls["numberOfTrimInflorescenceValue"].setValue(elements.value == null ? '' : elements.value);
                    this.FormCommonList.controls["numberOfTrimInflorescenceBefore"].setValue(elements.before);
                    break;
                }
              }

            }
          }
          if (growth_type == 'inflorescence') {
            for (let i = 0; i < response.params_list.length; i++) {
              const element = response.params_list[i];
              for (let j = 0; j < element.length; j++) {
                const elements = element[j];
                // console.log("v elements : ", elements)
                switch (elements.no) {
                  case 8:
                    this.FormInflorescenseList.controls["numberOffFlowerInflorescenceId"].setValue(elements._id);
                    this.FormInflorescenseList.controls["numberOffFlowerInflorescenceNo"].setValue(elements.no);
                    this.FormInflorescenseList.controls["numberOffFlowerInflorescenceInputType"].setValue(elements.input_type);
                    this.FormInflorescenseList.controls["numberOffFlowerInflorescenceCropGrowth"].setValue(elements.growth);
                    this.FormInflorescenseList.controls["numberOffFlowerInflorescenceOperator"].setValue(elements.operator == "+" ? true : false);
                    this.FormInflorescenseList.controls["numberOffFlowerInflorescenceValue"].setValue(elements.value == null ? '' : elements.value);
                    this.FormInflorescenseList.controls["numberOffFlowerInflorescenceBefore"].setValue(elements.before);
                    break;
                  case 9:
                    this.FormInflorescenseList.controls["numberOfFailFlowerId"].setValue(elements._id);
                    this.FormInflorescenseList.controls["numberOfFailFlowerNo"].setValue(elements.no);
                    this.FormInflorescenseList.controls["numberOfFailFlowerInputType"].setValue(elements.input_type);
                    this.FormInflorescenseList.controls["numberOfFailFlowerCropGrowth"].setValue(elements.growth);
                    this.FormInflorescenseList.controls["numberOfFailFlowerOperator"].setValue(elements.operator == "+" ? true : false);
                    this.FormInflorescenseList.controls["numberOfFailFlowerValue"].setValue(elements.value == null ? '' : elements.value);
                    this.FormInflorescenseList.controls["numberOfFailFlowerBefore"].setValue(elements.before);
                    break;
                  case 10:
                    this.numberOfGoodFlowerValue = elements.value == null ? '-' : elements.value
                    this.FormInflorescenseList.controls["numberOfGoodFlowerId"].setValue(elements._id);
                    this.FormInflorescenseList.controls["numberOfGoodFlowerNo"].setValue(elements.no);
                    this.FormInflorescenseList.controls["numberOfGoodFlowerInputType"].setValue(elements.input_type);
                    this.FormInflorescenseList.controls["numberOfGoodFlowerCropGrowth"].setValue(elements.growth);
                    this.FormInflorescenseList.controls["numberOfGoodFlowerOperator"].setValue(elements.operator == "+" ? true : false);
                    this.FormInflorescenseList.controls["numberOfGoodFlowerValue"].setValue(elements.value == null ? '' : elements.value);
                    this.FormInflorescenseList.controls["numberOfGoodFlowerBefore"].setValue(elements.before);
                    this.FormInflorescenseList.controls["numberOfGoodFlowerFormula"].setValue(elements.formula);

                    break;
                  case 11:
                    this.FormInflorescenseList.controls["numberOfAllPodId"].setValue(elements._id);
                    this.FormInflorescenseList.controls["numberOfAllPodNo"].setValue(elements.no);
                    this.FormInflorescenseList.controls["numberOfAllPodInputType"].setValue(elements.input_type);
                    this.FormInflorescenseList.controls["numberOfAllPodCropGrowth"].setValue(elements.growth);
                    this.FormInflorescenseList.controls["numberOfAllPodOperator"].setValue(elements.operator == "+" ? true : false);
                    this.FormInflorescenseList.controls["numberOfAllPodValue"].setValue(elements.value == null ? '' : elements.value);
                    this.FormInflorescenseList.controls["numberOfAllPodBefore"].setValue(elements.before);
                    break;
                  case 12:
                    this.FormInflorescenseList.controls["numberOfRottenPodId"].setValue(elements._id);
                    this.FormInflorescenseList.controls["numberOfRottenPodNo"].setValue(elements.no);
                    this.FormInflorescenseList.controls["numberOfRottenPodInputType"].setValue(elements.input_type);
                    this.FormInflorescenseList.controls["numberOfRottenPodCropGrowth"].setValue(elements.growth);
                    this.FormInflorescenseList.controls["numberOfRottenPodOperator"].setValue(elements.operator == "+" ? true : false);
                    this.FormInflorescenseList.controls["numberOfRottenPodValue"].setValue(elements.value == null ? '' : elements.value);
                    this.FormInflorescenseList.controls["numberOfRottenPodBefore"].setValue(elements.before);
                    break;
                  case 13:
                    this.FormInflorescenseList.controls["numberOfFallenPodId"].setValue(elements._id);
                    this.FormInflorescenseList.controls["numberOfFallenPodNo"].setValue(elements.no);
                    this.FormInflorescenseList.controls["numberOfFallenPodInputType"].setValue(elements.input_type);
                    this.FormInflorescenseList.controls["numberOfFallenPodCropGrowth"].setValue(elements.growth);
                    this.FormInflorescenseList.controls["numberOfFallenPodOperator"].setValue(elements.operator == "+" ? true : false);
                    this.FormInflorescenseList.controls["numberOfFallenPodValue"].setValue(elements.value == null ? '' : elements.value);
                    this.FormInflorescenseList.controls["numberOfFallenPodBefore"].setValue(elements.before);
                    break;
                  case 14:
                    this.FormInflorescenseList.controls["numberOfPodProblemsId"].setValue(elements._id);
                    this.FormInflorescenseList.controls["numberOfPodProblemsNo"].setValue(elements.no);
                    this.FormInflorescenseList.controls["numberOfPodProblemsInputType"].setValue(elements.input_type);
                    this.FormInflorescenseList.controls["numberOfPodProblemsCropGrowth"].setValue(elements.growth);
                    this.FormInflorescenseList.controls["numberOfPodProblemsOperator"].setValue(elements.operator == "+" ? true : false);
                    this.FormInflorescenseList.controls["numberOfPodProblemsValue"].setValue(elements.value == null ? '' : elements.value);
                    this.FormInflorescenseList.controls["numberOfPodProblemsBefore"].setValue(elements.before);
                    break;
                  case 15:
                    this.FormInflorescenseList.controls["numberOfBreedingIssueId"].setValue(elements._id);
                    this.FormInflorescenseList.controls["numberOfBreedingIssueNo"].setValue(elements.no);
                    this.FormInflorescenseList.controls["numberOfBreedingIssueInputType"].setValue(elements.input_type);
                    this.FormInflorescenseList.controls["numberOfBreedingIssueCropGrowth"].setValue(elements.growth);
                    this.FormInflorescenseList.controls["numberOfBreedingIssueOperator"].setValue(elements.operator == "+" ? true : false);
                    this.FormInflorescenseList.controls["numberOfBreedingIssueValue"].setValue(elements.value == null ? '' : elements.value);
                    this.FormInflorescenseList.controls["numberOfBreedingIssueBefore"].setValue(elements.before);
                    break;
                  case 16:
                    this.FormInflorescenseList.controls["numberOfGoodPodId"].setValue(elements._id);
                    this.FormInflorescenseList.controls["numberOfGoodPodNo"].setValue(elements.no);
                    this.FormInflorescenseList.controls["numberOfGoodPodInputType"].setValue(elements.input_type);
                    this.FormInflorescenseList.controls["numberOfGoodPodCropGrowth"].setValue(elements.growth);
                    this.FormInflorescenseList.controls["numberOfGoodPodOperator"].setValue(elements.operator == "+" ? true : false);
                    this.FormInflorescenseList.controls["numberOfGoodPodValue"].setValue(elements.value == null ? '' : elements.value);
                    this.FormInflorescenseList.controls["numberOfGoodPodBefore"].setValue(elements.before);
                    this.FormInflorescenseList.controls["numberOfGoodPodFormula"].setValue(elements.formula);

                    break;
                }
              }
            }
          }
          if (step !== null) this.getMap(this.currentPolygon,this.collectDateString,'map-show')
        }
        this.spinner.hide();
      });
  }

  DateDDMMYYYY(data) {
    if (!data) return ''
    return moment(data, 'YYYY-MM-DD HH:mm:ss', 'Asia/Bangkok').format('DD/MM/YYYY')
  }
  // Return/Refresh page ( Btn function )
  send_data() {
    $('#addgrowthSuccessmodal').modal('show');
  }
  cancel_send_data() {
    this.step = 1;
    this.FormCommonList.reset()
    this.FormInflorescenseList.reset()
    this.collectDate = null
    this.poleNo = '0';
    this.cropPoleName = '';
    this.experiments = '';
    this.growth_type = '';
    this.inflorescenceNo = '0';
    this.growthFormdata = null;
    this.getbyCropId(1)
    // window.location.reload()
  }

  // Add/Edit/Update/Delete growth ( Btn function )
  add_growth() {
    this.step = 2;
    this.spinner.show();
    setTimeout(async () => {
      await this.getInflorescence();
      await this.getPlotforMap(null,'map-add')
      this.spinner.hide();
    }, 500);

  }
  edit_growth(id, growth_type, inflorescence_no, date, inflorescence_name) {
    this.spinner.show();
    this.inflorescenceNo = inflorescence_no
    this.inflorescenceId = inflorescence_no,
      this.inflorescenceName = inflorescence_name,
      // this.collectDate = this.DateDDMMYYYY(date)
      // this.cropPoleId = pole_id
      // this.collectDateString = date
      this.step = 3
    console.log("edit_growth date : ", this.collectDate)
    setTimeout(async () => {
      await this.getInflorescence();
      await this.getPlotforMap(moment(date, 'YYYY-MM-DD').format('YYYY-MM-DD'),'map-edit')
      console.log("edit_growth date", date)
      // await this.getCropPloe(moment(date, 'YYYY-MM-DD').format('YYYY-MM-DD'))
      await this.preview_growth(id, growth_type, inflorescence_no, null);
      this.spinner.hide();
    }, 500);
  }
  delete_growth(id, growth_type, inflorescence_no) {
    this._id = id;
    this.growth_type = growth_type;
    this.inflorescence_no = inflorescence_no;
    console.log("this._id = ", this._id)
    console.log("this.growth_type = ", this.growth_type)
    console.log("this.inflorescence_no = ", this.inflorescence_no)
  }
  expandTrunk() {
    if (this.trunk == true) {
      this.trunk = false;
    } else if (this.trunk == false) {
      this.trunk = true;
    }
  }
  expandPerpole() {
    if (this.flowerperpole == true) {
      this.flowerperpole = false;
    } else if (this.flowerperpole == false) {
      this.flowerperpole = true;
    }
  }
  expandPerbouquet() {
    if (this.flowerperbouquet == true) {
      this.flowerperbouquet = false;
    } else if (this.flowerperbouquet == false) {
      this.flowerperbouquet = true;
    }
  }
  expandSheath() {
    if (this.sheath == true) {
      this.sheath = false;
    } else if (this.sheath == false) {
      this.sheath = true;
    }
  }
  calSum(formData) {
    console.log("formData : ", formData)
    console.log("this.ExstemLengthValue : ", this.ExstemLengthValue)
    console.log("formData.stemLengthBefore : ", formData.stemLengthBefore)
    console.log("formData.stemLengthValue : ", formData.stemLengthValue)
    if (formData.stemLengthOperator) this.SumstemLengthValue = formData.stemLengthBefore + formData.stemLengthValue
    else this.SumstemLengthValue = formData.stemLengthBefore - formData.stemLengthValue
    if (formData.numberOfInternodeOperator) this.SumnumberOfInternodeValue = formData.numberOfInternodeBefore + formData.numberOfInternodeValue
    else this.SumnumberOfInternodeValue = formData.numberOfInternodeBefore - formData.numberOfInternodeValue
    if (formData.numberOfShootTipOperator) this.SumnumberOfShootTipValue = formData.numberOfShootTipBefore + formData.numberOfShootTipValue
    else this.SumnumberOfShootTipValue = formData.numberOfShootTipBefore - formData.numberOfShootTipValue
    if (formData.numberOfInflorescenceOperator) this.SumnumberOfInflorescenceValue = formData.numberOfInflorescenceBefore + formData.numberOfInflorescenceValue
    else this.SumnumberOfInflorescenceValue = formData.numberOfInflorescenceBefore - formData.numberOfInflorescenceValue
    if (formData.numberOfTrimInflorescenceOperator) this.SumnumberOfTrimInflorescenceValue = formData.numberOfTrimInflorescenceBefore + formData.numberOfTrimInflorescenceValue
    else this.SumnumberOfTrimInflorescenceValue = formData.numberOfTrimInflorescenceBefore - formData.numberOfTrimInflorescenceValue
    console.log("this.SumstemLengthValue :", this.SumstemLengthValue)
  }
  isChange(previous, current) {
    if (previous == current) return false
    return true
  }
  validateCommonForm() {
    if (!this.FormCommonList.value.stemLengthValue && !this.FormCommonList.value.stemSizeValue && !this.FormCommonList.value.numberOfLeafValue && !this.FormCommonList.value.numberOfInternodeValue
      && !this.FormCommonList.value.numberOfShootTipValue && !this.FormCommonList.value.numberOfInflorescenceValue && !this.FormCommonList.value.SumnumberOfTrimInflorescenceValue) {
      return false
    }
    return true
  }
  chkConfirmCommonListSubmit(type) {
    // this.FormSubmit.value.startDate
    console.log("this.FormSubmit.value : ", this.FormCommonList.value)
    if (this.validateCommonForm()) {
      this.calSum(this.FormCommonList.value)
      let data = {
        zone_id: this.zoneId,
        plot_id: this.plotId,
        crop_id: this.cropId,
        crop_pole_id: this.cropPoleId,
        crop_pole_name: this.cropPoleName,
        date_string: this.collectDateString,
        common_list: [
          {
            crop_growth_param_id: this.FormCommonList.value.stemLengthId,
            no: this.FormCommonList.value.stemLengthNo,
            input_type: this.FormCommonList.value.stemLengthInputType,
            crop_growth: this.FormCommonList.value.stemLengthCropGrowth,
            operator: this.FormCommonList.value.stemLengthOperator == true ? "+" : "-",
            before: this.FormCommonList.value.stemLengthBefore,
            value: this.FormCommonList.value.stemLengthValue == "" ? null : this.FormCommonList.value.stemLengthValue,
            sum: this.SumstemLengthValue == 'null' || this.SumstemLengthValue == "" ? null : this.SumstemLengthValue,
            ex_operator: this.ExstemLengthOperator,
            ex_before: this.ExstemLengthBefore,
            ex_value: this.ExstemLengthValue,
            ex_sum: this.ExstemLengthSum,
            is_change: this.isChange(this.ExstemLengthValue, this.FormCommonList.value.stemLengthValue)
          },
          {
            crop_growth_param_id: this.FormCommonList.value.stemSizeId,
            no: this.FormCommonList.value.stemSizeNo,
            input_type: this.FormCommonList.value.stemSizeInputType,
            crop_growth: this.FormCommonList.value.stemSizeCropGrowth,
            operator: null,
            before: this.FormCommonList.value.stemSizeBefore,
            value: this.FormCommonList.value.stemSizeValue == "" ? null : this.FormCommonList.value.stemSizeValue,
            sum: this.SumstemSizeValue == 'null' || this.SumstemSizeValue == "" ? null : this.SumstemSizeValue,
            ex_operator: this.ExstemSizeOperator,
            ex_before: this.ExstemSizeBefore,
            ex_value: this.ExstemSizeValue,
            ex_sum: this.ExstemSizeSum,
            is_change: this.isChange(this.ExstemLengthValue, this.FormCommonList.value.stemLengthValue)

          },
          {
            crop_growth_param_id: this.FormCommonList.value.numberOfLeafId,
            no: this.FormCommonList.value.numberOfLeafNo,
            input_type: this.FormCommonList.value.numberOfLeafInputType,
            crop_growth: this.FormCommonList.value.numberOfLeafCropGrowth,
            operator: null,
            before: this.FormCommonList.value.numberOfLeafBefore,
            value: this.FormCommonList.value.numberOfLeafValue == "" ? null : this.FormCommonList.value.numberOfLeafValue,
            sum: this.SumnumberOfLeafValue == 'null' || this.SumnumberOfLeafValue == "" ? null : this.SumnumberOfLeafValue,
            ex_operator: this.ExnnumberOfLeafOperator,
            ex_before: this.ExnnumberOfLeafBefore,
            ex_value: this.ExnnumberOfLeafValue,
            ex_sum: this.ExnnumberOfLeafSum,
            is_change: this.isChange(this.ExnnumberOfLeafValue, this.FormCommonList.value.numberOfLeafValue)

          },
          {
            crop_growth_param_id: this.FormCommonList.value.numberOfInternodeId,
            no: this.FormCommonList.value.numberOfInternodeNo,
            input_type: this.FormCommonList.value.numberOfInternodeInputType,
            crop_growth: this.FormCommonList.value.numberOfInternodeCropGrowth,
            operator: this.FormCommonList.value.numberOfInternodeOperator == true ? "+" : "-",
            before: this.FormCommonList.value.numberOfInternodeBefore,
            value: this.FormCommonList.value.numberOfInternodeValue == "" ? null : this.FormCommonList.value.numberOfInternodeValue,
            sum: this.SumnumberOfInternodeValue == 'null' || this.SumnumberOfInternodeValue == "" ? null : this.SumnumberOfInternodeValue,
            ex_operator: this.ExnumberOfInternodeOperator,
            ex_before: this.ExnumberOfInternodeBefore,
            ex_value: this.ExnumberOfInternodeValue,
            ex_sum: this.ExnumberOfInternodeSum,
            is_change: this.isChange(this.ExnumberOfInternodeValue, this.FormCommonList.value.numberOfInternodeValue)

          },
          {
            crop_growth_param_id: this.FormCommonList.value.numberOfShootTipId,
            no: this.FormCommonList.value.numberOfShootTipNo,
            input_type: this.FormCommonList.value.numberOfShootTipInputType,
            crop_growth: this.FormCommonList.value.numberOfShootTipCropGrowth,
            operator: this.FormCommonList.value.numberOfShootTipOperator == true ? "+" : "-",
            before: this.FormCommonList.value.numberOfShootTipBefore,
            value: this.FormCommonList.value.numberOfShootTipValue == "" ? null : this.FormCommonList.value.numberOfShootTipValue,
            sum: this.SumnumberOfShootTipValue == 'null' || this.SumnumberOfShootTipValue == "" ? null : this.SumnumberOfShootTipValue,
            ex_operator: this.ExnumberOfShootTipOperator,
            ex_before: this.ExnumberOfShootTipBefore,
            ex_value: this.ExnumberOfShootTipValue,
            ex_sum: this.ExnumberOfShootTipSum,
            is_change: this.isChange(this.ExnumberOfShootTipValue, this.FormCommonList.value.numberOfShootTipValue)

          },
          {
            crop_growth_param_id: this.FormCommonList.value.numberOfInflorescenceId,
            no: this.FormCommonList.value.numberOfInflorescenceNo,
            input_type: this.FormCommonList.value.numberOfInflorescenceInputType,
            crop_growth: this.FormCommonList.value.numberOfInflorescenceCropGrowth,
            operator: this.FormCommonList.value.numberOfInflorescenceOperator == true ? "+" : "-",
            before: this.FormCommonList.value.numberOfInflorescenceBefore,
            value: this.FormCommonList.value.numberOfInflorescenceValue == "" ? null : this.FormCommonList.value.numberOfInflorescenceValue,
            sum: this.SumnumberOfInflorescenceValue == 'null' || this.SumnumberOfInflorescenceValue == "" ? null : this.SumnumberOfInflorescenceValue,
            ex_operator: this.ExnumberOfInflorescenceOperator,
            ex_before: this.ExnumberOfInflorescenceBefore,
            ex_value: this.ExnumberOfInflorescenceValue,
            ex_sum: this.ExnumberOfInflorescenceSum,
            is_change: this.isChange(this.ExnumberOfInflorescenceValue, this.FormCommonList.value.numberOfInflorescenceValue)
          },
          {
            crop_growth_param_id: this.FormCommonList.value.numberOfTrimInflorescenceId,
            no: this.FormCommonList.value.numberOfTrimInflorescenceNo,
            input_type: this.FormCommonList.value.numberOfTrimInflorescenceInputType,
            crop_growth: this.FormCommonList.value.numberOfTrimInflorescenceCropGrowth,
            operator: this.FormCommonList.value.numberOfTrimInflorescenceOperator == true ? "+" : "-",
            before: this.FormCommonList.value.numberOfTrimInflorescenceBefore,
            value: this.FormCommonList.value.numberOfTrimInflorescenceValue == "" ? null : this.FormCommonList.value.numberOfTrimInflorescenceValue,
            sum: this.SumnumberOfTrimInflorescenceValue == 'null' || this.SumnumberOfTrimInflorescenceValue == "" ? null : this.SumnumberOfTrimInflorescenceValue,
            ex_operator: this.ExnumberOfTrimInflorescenceOperator,
            ex_before: this.ExnumberOfTrimInflorescenceBefore,
            ex_value: this.ExnumberOfTrimInflorescenceValue,
            ex_sum: this.ExnumberOfTrimInflorescenceSum,
            is_change: this.isChange(this.ExnumberOfTrimInflorescenceValue, this.FormCommonList.value.numberOfTrimInflorescenceValue)
          },
        ]
      }
      console.log("this.FormSubmit.data  : ", data)

      // if (!this.FormSubmit.invalid) {
      this.spinner.show();
      this.phameeService.manageCropGrowthData(data)
        .subscribe(async success => {
          console.log("success : ", success)
          if (success.code == 200) {
            this._id = success.data._id
            this.growth_type = "pole"
            this.inflorescence_no = null;
            if(type=='add') $('#addgrowthSuccessmodal').modal('show');
            else $('#editgrowthSuccessmodal').modal('show');
            
          } else {
            $('#addgrowthFailmodal').modal('show');
          }
          this.spinner.hide();
        });
    }else{
      $('#addgrowthdAlertmodal').modal('show');
    }
  }
  validateInflorescenceForm() {
    if (!this.FormInflorescenseList.value.numberOffFlowerInflorescenceValue && !this.FormInflorescenseList.value.numberOfFailFlowerValue && !this.FormInflorescenseList.value.numberOfAllPodValue
      && !this.FormInflorescenseList.value.numberOfRottenPodValue && !this.FormInflorescenseList.value.numberOfFallenPodValue && !this.FormInflorescenseList.value.numberOfPodProblemsValue
      && !this.FormInflorescenseList.value.numberOfBreedingIssueValue) {
      return false
    }
    return true
  }
  chkConfirmInflorescenceListSubmit(type) {
    // this.FormSubmit.value.startDate
    console.log("this.FormInflorescenseList.value : ", this.FormInflorescenseList.value)
    if (this.validateInflorescenceForm()) {
      let data = {
        zone_id: this.zoneId,
        plot_id: this.plotId,
        crop_id: this.cropId,
        crop_pole_id: this.cropPoleId,
        crop_pole_name: this.cropPoleName,
        date_string: this.collectDateString,
        inflorescence_list: [{
          inflorescence_no: this.inflorescenceId,
          inflorescence_name: this.inflorescenceName,
          list: [
            {
              crop_growth_param_id: this.FormInflorescenseList.value.numberOffFlowerInflorescenceId,
              no: this.FormInflorescenseList.value.numberOffFlowerInflorescenceNo,
              input_type: this.FormInflorescenseList.value.numberOffFlowerInflorescenceInputType,
              crop_growth: this.FormInflorescenseList.value.numberOffFlowerInflorescenceCropGrowth,
              operator: null,
              before: null,
              value: this.FormInflorescenseList.value.numberOffFlowerInflorescenceValue == "" ? null : this.FormInflorescenseList.value.numberOffFlowerInflorescenceValue,
              sum: null,
            },
            {
              crop_growth_param_id: this.FormInflorescenseList.value.numberOfFailFlowerId,
              no: this.FormInflorescenseList.value.numberOfFailFlowerNo,
              input_type: this.FormInflorescenseList.value.numberOfFailFlowerInputType,
              crop_growth: this.FormInflorescenseList.value.numberOfFailFlowerCropGrowth,
              operator: null,
              before: null,
              value: this.FormInflorescenseList.value.numberOfFailFlowerValue == "" ? null : this.FormInflorescenseList.value.numberOfFailFlowerValue,
              sum: null,
            },
            {
              crop_growth_param_id: this.FormInflorescenseList.value.numberOfGoodFlowerId,
              no: this.FormInflorescenseList.value.numberOfGoodFlowerNo,
              input_type: this.FormInflorescenseList.value.numberOfGoodFlowerInputType,
              crop_growth: this.FormInflorescenseList.value.numberOfGoodFlowerCropGrowth,
              operator: null,
              before: null,
              value: this.FormInflorescenseList.value.numberOfGoodFlowerValue == "" ? null : this.FormInflorescenseList.value.numberOfGoodFlowerValue,
              sum: null,
            },
            {
              crop_growth_param_id: this.FormInflorescenseList.value.numberOfAllPodId,
              no: this.FormInflorescenseList.value.numberOfAllPodNo,
              input_type: this.FormInflorescenseList.value.numberOfAllPodInputType,
              crop_growth: this.FormInflorescenseList.value.numberOfAllPodCropGrowth,
              operator: null,
              before: null,
              value: this.FormInflorescenseList.value.numberOfAllPodValue == "" ? null : this.FormInflorescenseList.value.numberOfAllPodValue,
              sum: null,

            },
            {
              crop_growth_param_id: this.FormInflorescenseList.value.numberOfRottenPodId,
              no: this.FormInflorescenseList.value.numberOfRottenPodNo,
              input_type: this.FormInflorescenseList.value.numberOfRottenPodInputType,
              crop_growth: this.FormInflorescenseList.value.numberOfRottenPodCropGrowth,
              operator: null,
              before: null,
              value: this.FormInflorescenseList.value.numberOfRottenPodValue == "" ? null : this.FormInflorescenseList.value.numberOfRottenPodValue,
              sum: null,

            },
            {
              crop_growth_param_id: this.FormInflorescenseList.value.numberOfFallenPodId,
              no: this.FormInflorescenseList.value.numberOfFallenPodNo,
              input_type: this.FormInflorescenseList.value.numberOfFallenPodInputType,
              crop_growth: this.FormInflorescenseList.value.numberOfFallenPodCropGrowth,
              operator: null,
              before: null,
              value: this.FormInflorescenseList.value.numberOfFallenPodValue == "" ? null : this.FormInflorescenseList.value.numberOfFallenPodValue,
              sum: null,

            },
            {
              crop_growth_param_id: this.FormInflorescenseList.value.numberOfPodProblemsId,
              no: this.FormInflorescenseList.value.numberOfPodProblemsNo,
              input_type: this.FormInflorescenseList.value.numberOfPodProblemsInputType,
              crop_growth: this.FormInflorescenseList.value.numberOfPodProblemsCropGrowth,
              operator: null,
              before: null,
              value: this.FormInflorescenseList.value.numberOfPodProblemsValue == "" ? null : this.FormInflorescenseList.value.numberOfPodProblemsValue,
              sum: null,
            },
            {
              crop_growth_param_id: this.FormInflorescenseList.value.numberOfBreedingIssueId,
              no: this.FormInflorescenseList.value.numberOfBreedingIssueNo,
              input_type: this.FormInflorescenseList.value.numberOfBreedingIssueInputType,
              crop_growth: this.FormInflorescenseList.value.numberOfBreedingIssueCropGrowth,
              operator: null,
              before: null,
              value: this.FormInflorescenseList.value.numberOfBreedingIssueValue == "" ? null : this.FormInflorescenseList.value.numberOfBreedingIssueValue,
              sum: null,
            },
            {
              crop_growth_param_id: this.FormInflorescenseList.value.numberOfGoodPodId,
              no: this.FormInflorescenseList.value.numberOfGoodPodNo,
              input_type: this.FormInflorescenseList.value.numberOfGoodPodInputType,
              crop_growth: this.FormInflorescenseList.value.numberOfGoodPodCropGrowth,
              operator: null,
              before: null,
              value: this.FormInflorescenseList.value.numberOfGoodPodValue == "" ? null : this.FormInflorescenseList.value.numberOfGoodPodValue,
              sum: null,
            }
          ]
        }
        ]
      }
      console.log("data :", data)
      this.spinner.show();
      this.phameeService.manageCropGrowthData(data)
        .subscribe(async success => {
          console.log("success : ", success)
          if (success.code == 200) {
            this._id = success.data._id
            this.growth_type = "inflorescence"
            this.inflorescence_no = this.inflorescenceId;
            if(type=='add') $('#addgrowthSuccessmodal').modal('show');
            else $('#editgrowthSuccessmodal').modal('show');
          } else {
            $('#addgrowthFailmodal').modal('show');
          }
          this.spinner.hide();
        });
    } else {
      $('#addgrowthdAlertmodal').modal('show');
    }

  }
  deletebyId() {
    let data = {
      id: this._id,
      growth_type: this.growth_type,
      inflorescence_no: this.inflorescence_no
    }
    this.spinner.show();
    this.phameeService.deletebyId(data)
      .subscribe(async success => {
        console.log("deletebyId success : ", success)
        if (success.code == 200) {
          $('#deletegrowthSuccessmodal').modal('show');
        } else {
          $('#deletegrowthFailmodal').modal('show');
        }
        this.spinner.hide();
      });
  }
  reload() {
    this.spinner.show();
    setTimeout(() => {
      this.page = 1;
      this.cancel_send_data();
      this.getbyCropId(this.page);
      this.step = 1;
      this.cropPoleId = null
      this.spinner.hide();
    }, 100);
  }
  onClickGrowth(tabname){
    if (tabname == "pole") {
      $('#tab_inflorescence').removeClass('underline-li');
      $('#tab_pole').addClass('underline-li');
    }else if (tabname == "inflorescence") {
      $('#tab_inflorescence').addClass('underline-li');
      $('#tab_pole').removeClass('underline-li');
    }
  }
}
